import {
  OrangeDumbell,
  WorkoutCatgories,
  Difficulties,
} from "@utils/defaultImages";

export const icons = {
  equipmentCategories: {
    bgColor: "#FFF6F0",
    svg: <OrangeDumbell className="w-7 h-7" />,
  },
  difficultiesLevel: {
    bgColor: "#FFF0F0",
    svg: <Difficulties />,
  },
  workoutsCategories: {
    bgColor: "#FFF0FB",
    svg: <WorkoutCatgories />,
  },
};

// New structure for form fields, defined locally to use dynamic options
export const localExercisePreferences = [
  {
    label: "Equipment Categories",
    key: "equipmentCategories",
    type: "select",
  },
  {
    label: "Difficulties Level",
    key: "difficultiesLevel",
    type: "select",
  },
  {
    label: "Workouts Categories",
    key: "workoutsCategories",
    type: "multi-select", // Only this one is multi-select
  },
];